import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core'
import { FormArray, FormGroup } from '@angular/forms'
import { SelectOptionsService } from '@app/shared/services/select-options.service'
import { Telephone } from '@app/modules/telephone/telephone.model'
import { TelephoneFormService } from '@app/modules/telephone/telephone-form.service'
import { DeleteIdFormService } from '@app/modules/delete-id/delete-id-form.service'
import { ValidationService } from '@app/shared/services/validation.service'

@Component({
  selector: 'app-telephones-form-array',
  templateUrl: './telephones-form-array.component.html'
})

export class TelephonesFormArrayComponent implements OnInit, OnDestroy {

  /**
   * Display page
   */
  public display: boolean

  /**
   * Heading text
   */
  @Input() headingText: string

  /**
   * Button text
   */
  @Input() buttonText: string

  /**
   * Main form
   */
  @Input() mainForm: FormGroup

  /**
   * Main form change
   */
  @Output() mainFormChange: EventEmitter<FormGroup> = new EventEmitter<FormGroup>()

  /**
   * Constructor
   */
  public constructor (
    public selectOptionsService: SelectOptionsService,
    private telephoneFormService: TelephoneFormService,
    private deleteIdFormService: DeleteIdFormService,
    public validationService: ValidationService
  ) {}

  /**
   * On destroy
   */
  public ngOnDestroy (): void {}

  /**
   * On init
   */
  public ngOnInit (): void {
    this.display = true
  }

  /**
   * Add
   */
  public add (): void {
    const control: FormArray = this.mainForm.get('telephones') as FormArray
    const telephone: Telephone = new Telephone()
    const form: FormGroup = this.telephoneFormService.getForm(telephone, 'new')
    control.push(form)
    this.mainForm.markAsDirty()
  }

  /**
   * Remove
   *
   * @param {FormGroup} item Telephone
   */
  public remove (item: FormGroup): void {
    const control: FormArray = this.mainForm.get('telephones') as FormArray
    const index: number = control.controls.findIndex(x => x === item)
    const telephone: Telephone = new Telephone(item.value)

    if (telephone.uuid) {
      // Mark it for delete.
      const deleted: FormArray = this.mainForm.get('telephones' + 'Deleted') as FormArray
      deleted.push(this.deleteIdFormService.getForm({ uuid: telephone.uuid }))
    }

    control.removeAt(index)
    this.mainForm.markAsDirty()
  }

}
